import { makeAutoObservable, runInAction } from 'mobx';
import { getSuperAdmin, updateSuperAdmin } from '../../data/Config/SuperAdminManagement/repositories/superAdmin.repository';
import { SuperAdminResponse, SuperAdminRequest } from '../../data/Config/SuperAdminManagement/schemas';
//import { F1PasswordManagement, GetF1PasswordManagementRequest, UpdateF1PasswordManagementRequest } from '../../data/Config/F1PasswordManagement/schemas';
import RootStore from '../Root.store';

class SuperAdminManagementStore {
    private _superAdminManagement: SuperAdminResponse | undefined = undefined;

    public get superAdminManagement() {
        return this._superAdminManagement;
    }

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    public async fetchSuperAdminManagement() {
        const [error, superAdminManagementResponse] = await getSuperAdmin();
        if (error) {
            throw error;
        }
        runInAction(() => {
            this._superAdminManagement = superAdminManagementResponse;
        });
    }

    public async updateSuperAdminManagement(superAdminRequest: SuperAdminRequest) {
        const [error, superAdminManagementResponse] = await updateSuperAdmin(superAdminRequest);
        if (error) {
            throw error;
        }
        runInAction(() => {
            this._superAdminManagement = superAdminManagementResponse;
        });
    }
}

export default SuperAdminManagementStore;
